import { render, staticRenderFns } from "./all_settings.vue?vue&type=template&id=1934dc76&scoped=true"
var script = {}
import style0 from "./all_settings.vue?vue&type=style&index=0&id=1934dc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1934dc76",
  null
  
)

export default component.exports